import { render, staticRenderFns } from "./ItemTodasMensagens.vue?vue&type=template&id=37862107&scoped=true&"
import script from "./ItemTodasMensagens.vue?vue&type=script&lang=js&"
export * from "./ItemTodasMensagens.vue?vue&type=script&lang=js&"
import style0 from "./ItemTodasMensagens.vue?vue&type=style&index=0&id=37862107&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37862107",
  null
  
)

export default component.exports